import { render, staticRenderFns } from "./SpotSummaryPanel.global.vue?vue&type=template&id=5de338c2&lang=pug&"
import script from "./SpotSummaryPanel.global.vue?vue&type=script&lang=ts&"
export * from "./SpotSummaryPanel.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports